import { render, staticRenderFns } from "./product-variants-table-head.vue?vue&type=template&id=656acaf1"
import script from "./product-variants-table-head.vue?vue&type=script&lang=js"
export * from "./product-variants-table-head.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-load_72a858df71aeaca8538e59a65db64572/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports